export default "__VITE_ASSET__EZZc6poV__"